import axios from 'axios';

const defaultOptions: object = {
    withCredentials: true
};

class ApiRequest {
    static async get<T = any>(url: string, options = {} as object): Promise<T> {
        const config = { ...defaultOptions, ...options };
        const response = await axios.get(url, config);

        return response.data;
    }
}

export default ApiRequest;
